// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"300":"dca0ddbb","893":"dca0ddbb"}[chunkId] + ".chunk.css";
};